import { GetBaseOptions } from 'api/requestsTypes/get'
import { LMCRequest as LmcRequest } from './types'
import { ResidentItem, ResidentNeed } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'

const list: LmcRequest<
  { result: ResidentItem[] },
  { anyStatus: boolean },
  GetBaseOptions
> = () => getJSON({ url: 'residents' })

const fetch: LmcRequest<
  { result: ResidentItem },
  { id: string },
  GetBaseOptions
> = ({ params }) => getJSON({ url: `/api/list/residents/${params?.id}` })

const needsList: LmcRequest<
  { result: ResidentNeed[] },
  { id: string },
  GetBaseOptions
> = ({ params }) => getJSON({ url: `/api/list/residents/${params?.id}/needs` })

export const residentsRequests = {
  list,
  fetch,
  needsList,
}
